import PropTypes from 'prop-types';
import React  from 'react';
import styles from './Accordion.scss';
import CSSModules from "react-css-modules";


@CSSModules(styles, { allowMultiple: true })
class  AccordionItem extends React.Component{

  constructor(props) {
    super(props);
    this.title = props.title;
    this.children = props.children;
  }

  handleOnClick = () => {
    this.props.handleToggle(this.props.isActive ? -1 :this.props.index);
  }

 render()
  {
    return (
    <div styleName="accordionItemContainer" data-at={`accordion-item-${this.props.path}`}>
      <div   onClick={this.handleOnClick.bind(this)} styleName={"accordionTitle"}>
        <div data-at={`accordion-item-title-${this.props.path}`}>{this.title}</div>
        <div styleName={this.props.isActive ? 'arrowDown' : 'arrowUp'}/>
      </div>
      {this.props.isActive && <div styleName={'itemContainer'}>{this.children}</div>}
    </div>
    );
    }
}

AccordionItem.propTypes = {

  title: PropTypes.string,
  handleClick : PropTypes.func,
  items : PropTypes.array

};

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/components/common/Accordion/AccordionItem.js